
import { MapPin, Clock, Navigation } from 'lucide-react';
import { consultorios } from '@/data/consultorios';

export function OfficeLocations() {
  return (
    <section className="py-14 bg-white border-t border-gray-100">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="text-center mb-8">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Localização</p>
          <h2 className="text-2xl font-bold text-gray-800 font-primary">Nossos Consultórios</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {consultorios.map((c) => (
            <div key={c.id} className="rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200">
              {/* green header */}
              <div className="bg-brand-primary px-5 py-4">
                <h3 className="text-sm font-bold text-white font-primary leading-tight">{c.name}</h3>
                <p className="text-white/70 text-xs mt-0.5">{c.city}</p>
              </div>

              {/* body */}
              <div className="bg-white px-5 py-4 space-y-3 text-sm text-gray-600">
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-brand-primary mt-0.5 shrink-0" />
                  <span className="leading-snug">{c.address}{c.complement ? ` – ${c.complement}` : ''}</span>
                </div>
                <div className="flex items-start gap-2">
                  <Clock className="w-4 h-4 text-brand-primary mt-0.5 shrink-0" />
                  <div className="space-y-0.5">
                    {c.horarios.map((h, i) => <p key={i}>{h}</p>)}
                  </div>
                </div>

                <button
                  onClick={() => window.open(c.googleMapsUrl, '_blank')}
                  className="flex items-center gap-1.5 text-brand-primary text-xs font-semibold mt-1 hover:underline"
                >
                  <Navigation className="w-3.5 h-3.5" />
                  Ver no mapa
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
